import React, { useState } from "react";
import { 
  SunIcon, 
  PlusIcon,
  PencilSquareIcon, // 31 Mar 2026
  PlusCircleIcon,   // 31 Mar 2026
  ArrowUpCircleIcon,// 31 Mar 2026
 } from "@heroicons/react/24/outline";

import EtWabActionIcon1SVGComp from "@/assets/img/icons/svgComp/EtWabActionIcon1SVGComp";
import EtWabReflectionIcon1SVGComp from "@/assets/img/icons/svgComp/EtWabReflectionIcon1SVGComp";
import EtWabConversationIcon1SVGComp from "@/assets/img/icons/svgComp/EtWabConversationIcon1SVGComp";
import EtWabCreationIcon1SVGComp from "@/assets/img/icons/svgComp/EtWabCreationIcon1SVGComp";

import EtTrinityMorningHabitsChartDemo from "./EtTrinityMorningHabitsChartDemo";
import EtTrinityReflectionsChartDemo from "./EtTrinityReflectionsChartDemo";
import EtTrinityConversationsChartDemo from "./EtTrinityConversationsChartDemo";
import EtTrinityCreationsChartDemo from "./EtTrinityCreationsChartDemo";

// 27 Mar 2026 
import EtTrinityActionsChartDemo from "./EtTrinityActionsChartDemo";

// 31 Mar 2026
import { CircularProgressbar, buildStyles } from "react-circular-progressbar";
import "react-circular-progressbar/dist/styles.css";

const EtTrinityOnboardingBeginContent = () => {
  // Author - Atul Pandey
  // First Created - 16 Mar 2026
  // Purpose - reusable begin section content block for Purpose Native onboarding
  // Updated - 16 Mar 2026 - added tabbed structure for navigation / steps / visualize
  // Updated - 25 Mar 2026 - Copy refinements
  // Updated - 26 Mar 2026 - Copy and JSX refinements - navigationPath in beginItems array
  // Updated - 27 Mar 2026 - Copy and JSX refinements - navigationPath for Actions and Actions Visualization
  // Updated - 29 Mar 2026 - Copy and JSX refinements - guidingSteps refinements - Reflections, Conversations, Creations
  // Updated - 30 Mar 2026 - Copy and JSX refinements - guidingSteps refinements - Actions
  // Updated - 31 Mar 2026 - Copy and JSX refinements - guidingSteps refinements - Numbering issue on Create Update Tab
  // Updated - 02 Apr 2026 - Copy refinements - beginItems

  const [activeTabs, setActiveTabs] = useState({});

  const handleTabChange = (id, tab) => {
    setActiveTabs((prev) => ({
      ...prev,
      [id]: tab,
    }));
  };

  // 30 Mar 2026
  const ActionGuidingTabs = () => {
    const [activeActionGuideTab, setActiveActionGuideTab] = useState("create");

    const createSteps = [
      () => (
        <p className="text-sm text-gray-600 leading-6">
          <span className="inline-flex items-center px-2 py-0.5 rounded-full bg-orange-100 border border-orange-200 text-orange-800 font-semibold text-xs">
            Actions
          </span>{" "}
          are the backbone of demonstrating your{" "}
          <span className="font-semibold text-gray-800 bg-orange-100 px-2 rounded-full">
            mission performance
          </span>
          .
        </p>
      ),
      () => (
        <div className="space-y-2">
          <p className="text-sm text-gray-600 leading-6">
            For now, select{" "}
            <span className="font-semibold text-gray-800 bg-orange-100 px-2 rounded-full">
              MyMissions
            </span>{" "}
            as the trail for everyday actions.
          </p>

          {/* Demo - Trail Selection */}
          <div className="bg-gray-50 border border-gray-200 rounded p-2">
            <p className="text-xs font-bold text-orange-800 mb-1">Trail</p>
            <select
              className="w-full rounded p-2 text-xs border border-gray-300 focus:outline-none focus:ring-1 focus:ring-orange-500"
              disabled
              value="mymissions"
            >
              <option value="mymissions">MyMissions</option>
            </select>
          </div>
        </div>
      ),
      () => (
        <div className="space-y-2">
          <p className="text-sm text-gray-600 leading-6">
            If you are using{" "}
            <span className="inline-flex items-center px-2 py-0.5 rounded-full bg-gray-100 border border-gray-200 text-gray-800 font-semibold text-xs">
              MyMissions
            </span>
            , choose a{" "}
            <span className="font-semibold text-gray-800 bg-orange-100 px-2 rounded-full">
              Focus Area
            </span>{" "}
            such as Self, Clients, Org, Partner or Team. This helps connect the action to a target or constituency.
          </p>

          {/* Demo - Focus Area */}
          <div className="bg-gray-50 border border-gray-200 rounded p-2">
            <p className="text-xs font-bold text-orange-800 mb-1">
              Focus Area{" "}
              <span className="font-normal text-gray-500 italic">
                (e.g., Self, Client, Org...)
              </span>
            </p>

            <select
              className="w-full border border-gray-300 rounded p-2 text-xs focus:outline-none focus:ring-1 focus:ring-orange-500"
              disabled
              value="Org"
            >
              <option value="Self">Self</option>
              <option value="Client">Client</option>
              <option value="Org">Org</option>
              <option value="Team">Team</option>
              <option value="Partner">Partner</option>
            </select>
          </div>
        </div>
      ),
      () => (
        <div className="space-y-2">
          <p className="text-sm text-gray-600 leading-6">
            Then select the connected{" "}
            <span className="font-semibold text-gray-800 bg-orange-100 px-2 rounded-full">
              Vision
            </span>
            , and if available, a{" "}
            <span className="font-semibold text-gray-800 bg-orange-100 px-2 rounded-full">
              Mission
            </span>
            ,{" "}
            <span className="font-semibold text-gray-800 bg-orange-100 px-2 rounded-full">
              Goal
            </span>
            , and{" "}
            <span className="font-semibold text-gray-800 bg-orange-100 px-2 rounded-full">
              Goal Period
            </span>
            .
          </p>

          {/* Demo - Vision / Mission / Goal / Goal Period */}
          <div className="bg-gray-50 border border-gray-200 rounded p-2 space-y-2">
            
            {/* Vision */}
            <div>
              <p className="text-xs font-bold text-orange-800 mb-1">Vision</p>
              <select
                className="w-full border border-gray-300 rounded p-2 text-xs focus:outline-none focus:ring-1 focus:ring-orange-500"
                disabled
              >
                <option>Select Vision</option>
                <option>Build a high performance growth organization</option>
              </select>
            </div>

            {/* Mission */}
            <div>
              <p className="text-xs font-bold text-orange-800 mb-1">Mission</p>
              <select
                className="w-full border border-gray-300 rounded p-2 text-xs focus:outline-none focus:ring-1 focus:ring-orange-500"
                disabled
              >
                <option>Select Mission</option>
                <option>Drive client growth through strategic conversations</option>
              </select>
            </div>

            {/* Goal */}
            <div>
              <p className="text-xs font-bold text-orange-800 mb-1">Goal</p>
              <select
                className="w-full border border-gray-300 rounded p-2 text-xs focus:outline-none focus:ring-1 focus:ring-orange-500"
                disabled
              >
                <option>Select Goal</option>
                <option>Close 5 strategic client opportunities</option>
              </select>
            </div>

            {/* Goal Period */}
            <div>
              <p className="text-xs font-bold text-orange-800 mb-1">Goal Period</p>
              <div className="flex flex-wrap gap-2">
                <span className="px-2 py-0.5 rounded-full text-[10px] bg-orange-500 text-white">
                  Q1
                </span>
                <span className="px-2 py-0.5 rounded-full text-[10px] bg-gray-100 border border-gray-300 text-gray-700">
                  Q2
                </span>
              </div>
            </div>

          </div>
        </div>
      ),
      () => (
        <div className="space-y-2">
          <p className="text-sm text-gray-600 leading-6">
            If a{" "}
            <span className="font-semibold text-gray-800 bg-orange-100 px-2 rounded-full">
              Vision
            </span>{" "}
            does not exist for that Focus Area, create it first by going to{" "}
            <span className="font-semibold text-gray-800 bg-orange-100 px-2 rounded-full">
              Imprint → Imagine → Vision
            </span>{" "}
            and then selecting that Focus Area.
          </p>

          <p className="text-sm text-gray-600 leading-6">
            If a{" "}
            <span className="font-semibold text-gray-800 bg-orange-100 px-2 rounded-full">
              Mission
            </span>{" "}
            does not exist yet, go to{" "}
            <span className="font-semibold text-gray-800 bg-orange-100 px-2 rounded-full">
              Imprint → Imagine → Missions
            </span>{" "}
            and create the mission for that Focus Area and Vision.
          </p>

          <p className="text-sm text-gray-600 leading-6">
            If a{" "}
            <span className="font-semibold text-gray-800 bg-orange-100 px-2 rounded-full">
              Goal
            </span>{" "}
            does not exist, go to{" "}
            <span className="font-semibold text-gray-800 bg-orange-100 px-2 rounded-full">
              Imprint → Imagine → Missions
            </span>{" "}
            and add the Goal under the Mission, along with its goal periods if needed.
          </p>
        </div>
      ),
      () => (
        <div className="space-y-2">
          <p className="text-sm text-gray-600 leading-6">
            Choose whether the action is an{" "}
            <span className="font-semibold text-gray-800 bg-orange-100 px-2 rounded-full">
              Enabler
            </span>{" "}
            or an{" "}
            <span className="font-semibold text-gray-800 bg-orange-100 px-2 rounded-full">
              Outcome
            </span>
            . Enablers support progress. Outcomes directly contribute to the target.
          </p>

          {/* Demo - Action Goal Role */}
          <div className="bg-gray-50 border border-gray-200 rounded p-2">
            <p className="text-xs font-bold text-orange-800 mb-1">
              Action's Goal Role
            </p>

            <div className="flex space-x-2">
              

              <button
                type="button"
                className="px-3 py-1 rounded-full text-xs font-semibold border bg-orange-500 text-white border-orange-600"
                disabled
              >
                Enabler
              </button>

              <button
                type="button"
                className="px-3 py-1 rounded-full text-xs font-semibold border bg-white text-gray-800 border-gray-300"
                disabled
              >
                Outcome
              </button>
            </div>
          </div>
        </div>
      ),
      () => (
        <div className="space-y-2">
          <p className="text-sm text-gray-600 leading-6">
            Select{" "}
            <span className="inline-flex items-center px-2 py-0.5 rounded-full bg-gray-100 border border-gray-200 text-gray-800 font-semibold text-xs">
              Execute &amp; Review
            </span>{" "}
            as the session for MyMissions, and choose the appropriate{" "}
            <span className="font-semibold text-gray-800 bg-orange-100 px-2 rounded-full">
              Action Type
            </span>
            .
          </p>

          {/* Demo - Session & Action Type */}
          <div className="bg-gray-50 border border-gray-200 rounded p-2 space-y-2">
            
            {/* Session */}
            <div>
              <p className="text-xs font-bold text-orange-800 mb-1">Session</p>
              <select
                className="w-full rounded p-2 text-xs border border-gray-300 focus:outline-none focus:ring-1 focus:ring-orange-500"
                disabled
                value="executeReview"
              >
                <option value="executeReview">Execute &amp; Review</option>
              </select>
            </div>

            {/* Action Type */}
            <div>
              <p className="text-xs font-bold text-orange-800 mb-1">Action Type</p>
              <select
                className="w-full rounded p-2 text-xs border border-gray-300 focus:outline-none focus:ring-1 focus:ring-orange-500"
                disabled 
                // value={'Review'}
              >
                <option>Select Action Type</option>
                <option>Review</option>
                <option>Client Engagement</option>
                <option>Internal Alignment</option>
              </select>
            </div>

          </div>
        </div>
      ),
      () => (
        <div className="space-y-2">
          <p className="text-sm text-gray-600 leading-6">
            If you are an{" "}
            <span className="font-semibold text-gray-800 bg-orange-100 px-2 rounded-full">
              OrgSponsor
            </span>
            , you may also assign the action to another team member.
          </p>

          {/* Demo - Assign Action */}
          <div className="bg-gray-50 border border-gray-200 rounded p-2">
            
            {/* Checkbox */}
            <div className="flex items-center gap-2">
              <input type="checkbox" checked disabled />
              <label className="text-xs font-bold text-orange-800">
                Assign this Action?
              </label>
            </div>

            {/* Assign To */}
            <p className="text-xs font-bold text-orange-800 mt-2">
              Assign To
            </p>

            <div className="flex flex-wrap gap-2 bg-white rounded p-2 border border-gray-200">
              
              {/* Selected */}
              <span className="px-3 py-1 rounded-full text-xs border font-medium bg-orange-500 text-white border-orange-500">
                Ava Sharma - Sales Lead
              </span>

              {/* Unselected */}
              <span className="px-3 py-1 rounded-full text-xs border font-medium bg-white text-gray-700 border-gray-300">
                Rohan Mehta - Delivery Head
              </span>

              <span className="px-3 py-1 rounded-full text-xs border font-medium bg-white text-gray-700 border-gray-300">
                Maya Chen - Strategy
              </span>

            </div>
          </div>
        </div>
      ),
      () => (
        <div className="space-y-2">
          <p className="text-sm text-gray-600 leading-6">
            Add the{" "}
            <span className="font-semibold text-gray-800 bg-orange-100 px-2 rounded-full">
              Action Name
            </span>
            ,{" "}
            <span className="font-semibold text-gray-800 bg-orange-100 px-2 rounded-full">
              Complete By
            </span>{" "}
            date, and if needed, the{" "}
            <span className="font-semibold text-gray-800 bg-orange-100 px-2 rounded-full">
              Target Value
            </span>{" "}
            and{" "}
            <span className="font-semibold text-gray-800 bg-orange-100 px-2 rounded-full">
              Unit of Measure
            </span>
            . For some Outcome actions, these may auto populate from the Goal.
          </p>

          {/* Demo - Action Details */}
          <div className="bg-gray-50 border border-gray-200 rounded p-2 space-y-2">

            {/* Action Name */}
            <div>
              <p className="text-xs font-bold text-orange-800 mb-1">Action Name</p>
              <input
                type="text"
                placeholder="Enter Action Name"
                className="w-full rounded p-2 text-xs border border-gray-300 focus:outline-none focus:ring-1 focus:ring-orange-500"
                disabled
              />
            </div>

            {/* Completion Date */}
            <div>
              <p className="text-xs font-bold text-orange-800 mb-1">Action Complete By</p>
              <input
                type="date"
                className="w-full rounded p-2 text-xs border border-gray-300 focus:outline-none focus:ring-1 focus:ring-orange-500"
                disabled
              />
            </div>

            {/* Target Value & UoM */}
            <div className="flex gap-2">
              <div className="w-full">
                <p className="text-xs font-bold text-orange-800 mb-1">Target Value</p>
                <input
                  type="number"
                  placeholder="0"
                  className="w-full rounded p-2 text-xs border border-gray-300"
                  disabled
                />
              </div>

              <div className="w-full">
                <p className="text-xs font-bold text-orange-800 mb-1">Unit of Measure</p>
                <input
                  type="text"
                  placeholder="e.g., leads contacted"
                  className="w-full rounded p-2 text-xs border border-gray-300"
                  disabled
                />
              </div>
            </div>

          </div>
        </div>
      ),
      () => (
        <div className="space-y-2">
          <p className="text-sm text-gray-600 leading-6">
            If the action needs repeated tracking, choose a{" "}
            <span className="font-semibold text-gray-800 bg-orange-100 px-2 rounded-full">
              Recurrence Pattern
            </span>{" "}
            such as Daily, Weekly, Monthly, Quarterly or more, along with recurrence start and end dates.
          </p>

          {/* Demo - Recurrence Pattern */}
          <div className="bg-gray-50 border border-gray-200 rounded p-2 space-y-2">
            <div>
              <p className="text-xs font-bold text-orange-800 mb-1">Recurrence Pattern</p>
              <div className="flex flex-wrap gap-2">
                <button
                  type="button"
                  className="rounded-full px-3 py-1 text-xs border bg-white text-gray-600 border-gray-300"
                  disabled
                >
                  One-Time
                </button>
                <button
                  type="button"
                  className="rounded-full px-3 py-1 text-xs border bg-orange-500 text-white font-bold border-orange-500"
                  disabled
                >
                  Daily
                </button>
                <button
                  type="button"
                  className="rounded-full px-3 py-1 text-xs border bg-white text-gray-600 border-gray-300"
                  disabled
                >
                  Weekly
                </button>
                <button
                  type="button"
                  className="rounded-full px-3 py-1 text-xs border bg-white text-gray-600 border-gray-300"
                  disabled
                >
                  Monthly
                </button>
                <button
                  type="button"
                  className="rounded-full px-3 py-1 text-xs border bg-white text-gray-600 border-gray-300"
                  disabled
                >
                  Quarterly
                </button>
              </div>
            </div>

            <div>
              <p className="text-xs font-bold text-orange-800 mb-1">Recurrence Start Date</p>
              <input
                type="date"
                className="w-full border border-gray-300 rounded p-2 text-xs focus:outline-none focus:ring-1 focus:ring-orange-500"
                disabled
              />
            </div>

            <div>
              <p className="text-xs font-bold text-orange-800 mb-1">Recurrence End Date</p>
              <input
                type="date"
                className="w-full border border-gray-300 rounded p-2 text-xs focus:outline-none focus:ring-1 focus:ring-orange-500"
                disabled
              />
            </div>

            <div>
              <p className="text-xs font-bold text-orange-800 mb-1">Weekdays Only?</p>
              <div className="flex items-center space-x-2">
                <button
                  type="button"
                  className="px-3 py-1 rounded-full text-xs font-semibold border bg-orange-500 text-white border-orange-500"
                  disabled
                >
                  Yes
                </button>
                <button
                  type="button"
                  className="px-3 py-1 rounded-full text-xs font-semibold border bg-white text-gray-800 border-gray-300"
                  disabled
                >
                  No
                </button>
              </div>
            </div>
          </div>
        </div>
      ),
      () => (
        <div className="space-y-2">
          <p className="text-sm text-gray-600 leading-6">
            Add the{" "}
            <span className="font-semibold text-gray-800 bg-orange-100 px-2 rounded-full">
              Action Description
            </span>{" "}
            to capture further detail, breakdown, actors or links, and then press{" "}
            <span className="font-semibold text-gray-800 bg-orange-100 px-2 rounded-full">
              Create
            </span>
            .
          </p>

          {/* Demo - Action Description */}
          <div className="bg-gray-50 border border-gray-200 rounded p-2 space-y-2">
            
            <div>
              <p className="text-xs font-bold text-orange-800 mb-1">
                Action Description
              </p>
              <textarea
                rows={3}
                placeholder="Enter Action Description"
                className="w-full rounded p-2 text-xs border border-gray-300 focus:outline-none focus:ring-1 focus:ring-orange-500"
                disabled
              />
            </div>

            {/* Demo - Action Buttons */}
            <div className="bg-white px-2 py-2 rounded flex justify-start">
              <button
                type="button"
                className="border border-orange-600 text-orange-600 w-24 px-2 py-1 text-xs rounded-full mx-1"
                disabled
              >
                Create
              </button>

              <button
                type="button"
                className="border border-orange-600 text-orange-600 w-24 px-2 py-1 text-xs rounded-full mx-1"
                disabled
              >
                Cancel
              </button>
            </div>

          </div>
        </div>
      ),
      () => (
        <div className="space-y-2">
          <p className="text-sm text-gray-600 leading-6">
            Once created, the action appears in the{" "}
            <span className="font-semibold text-gray-800 bg-orange-100 px-2 rounded-full">
              Action Center
            </span>{" "}
            inside the MyMissions action backbone.
          </p>

          {/* Demo - Mock drill down like Action Center */}
          <div className="bg-white border border-gray-200 rounded p-2 space-y-2">

            {/* Top context */}
            <div className="flex items-center gap-2 text-[10px] border-b border-gray-200 pb-2">
              <span className="px-2 py-0.5 rounded-full bg-orange-100 text-orange-800 font-semibold">
                MyMissions
              </span>
              <span className="px-2 py-0.5 rounded-full bg-orange-500 text-white font-semibold">
                Org
              </span>
            </div>

            {/* Vision block */}
            <div className="bg-white rounded p-1 border border-gray-200">
              <div className="grid grid-cols-12 items-center">
                <div className="col-span-8 flex items-center">
                  <span className="text-orange-600 text-xs font-bold">−</span>
                  <span className="ml-2 text-orange-600 text-xs font-bold">Vision :</span>
                  <span className="ml-2 text-xs font-semibold text-gray-800">
                    Build a stronger client growth engine
                  </span>
                </div>
                <div className="col-span-4 flex justify-end">
                  <span className="h-5 w-5 rounded-full border border-orange-300 bg-gray-50 text-[10px] text-orange-600 flex items-center justify-center">
                    1
                  </span>
                </div>
              </div>

              {/* Mission block */}
              <div className="ml-4 mt-2 bg-orange-50 rounded p-1 border border-orange-100">
                <div className="grid grid-cols-12 items-center">
                  <div className="col-span-8 flex items-center">
                    <span className="text-orange-600 text-xs font-bold">−</span>
                    <span className="ml-2 text-orange-600 text-xs font-bold">Mission :</span>
                    <span className="ml-2 text-xs font-semibold text-gray-800">
                      Improve quality of strategic deal pursuit
                    </span>
                  </div>
                  <div className="col-span-4 flex justify-end">
                    <span className="h-5 w-5 rounded-full border border-orange-300 bg-gray-50 text-[10px] text-orange-600 flex items-center justify-center">
                      1
                    </span>
                  </div>
                </div>

                {/* Goal block */}
                <div className="ml-4 mt-2 bg-gray-200 rounded p-1 border border-gray-300">
                  <div className="grid grid-cols-12 items-center">
                    <div className="col-span-8 flex items-center">
                      <span className="text-orange-600 text-xs font-bold">−</span>
                      <span className="ml-2 text-orange-600 text-xs font-bold">Goal :</span>
                      <span className="ml-2 text-xs font-semibold text-gray-800">
                        Improve pipeline conversion by 10%
                      </span>
                    </div>
                    <div className="col-span-4 flex justify-end">
                      <span className="h-5 w-5 rounded-full border border-orange-300 bg-gray-50 text-[10px] text-orange-600 flex items-center justify-center">
                        1
                      </span>
                    </div>
                  </div>

                  {/* Goal Period block */}
                  <div className="ml-4 mt-2 bg-orange-100 rounded p-1 border border-orange-200">
                    <div className="grid grid-cols-12 items-center">
                      <div className="col-span-8 flex items-center">
                        <span className="text-orange-600 text-xs font-bold">−</span>
                        <span className="ml-2 text-orange-600 text-xs font-bold">Goal Period :</span>
                        <span className="ml-2 text-xs font-semibold text-gray-800">
                          Q2 FY26
                        </span>
                      </div>
                      <div className="col-span-4 flex justify-end">
                        <span className="h-5 w-5 rounded-full border border-orange-300 bg-gray-50 text-[10px] text-orange-600 flex items-center justify-center">
                          1
                        </span>
                      </div>
                    </div>

                    {/* Action Type block */}
                    <div className="ml-4 mt-2 bg-gray-200 rounded p-1 shadow-sm">
                      <div className="flex items-center">
                        <span className="text-orange-600 text-xs font-bold">−</span>
                        <span className="ml-2 text-xs font-bold text-gray-600">Action Type :</span>
                        <span className="ml-2 text-xs font-bold text-gray-800">
                          Review
                        </span>
                        <span className="ml-2 h-5 w-5 rounded-full border border-orange-300 bg-gray-50 text-[10px] text-orange-600 flex items-center justify-center">
                          1
                        </span>
                      </div>

                      {/* Action card */}
                      <div className="mt-2 bg-gray-100 rounded p-2">
                        <div className="grid grid-cols-12 items-center gap-2">
                          <div className="col-span-4 flex items-center">
                            <div className="h-5 w-5 rounded-full flex justify-center items-center bg-white hover:bg-orange-100">
                              <span className="text-orange-600 text-[10px] font-bold">+</span>
                            </div>

                            <p className="text-xs text-gray-600 font-bold ml-2">1.</p>

                            {/* <div className="ml-2 flex items-center gap-1">
                              <span className="h-5 w-5 rounded-full bg-white flex items-center justify-center text-[9px] text-orange-600 border border-gray-200">
                                G
                              </span>
                              <span className="h-5 w-5 rounded-full bg-white flex items-center justify-center text-[9px] text-orange-600 border border-gray-200">
                                O
                              </span>
                              <span className="h-5 w-5 rounded-full bg-white flex items-center justify-center text-[9px] text-orange-600 border border-gray-200">
                                R
                              </span>
                            </div> */}

                            <p className="text-xs font-bold ml-2 text-gray-800">
                              Review top 5 pipeline opportunities
                            </p>
                          </div>

                          <div className="col-span-2">
                            <div className="rounded-full bg-gray-300 relative h-3">
                              <div
                                className="rounded-full bg-[#552a9a] h-3"
                                style={{ width: "45%" }}
                              ></div>
                              <p className="text-[8px] absolute top-1/2 left-1/2 -translate-x-1/2 -translate-y-1/2 text-black">
                                45%
                              </p>
                            </div>
                          </div>

                          <div className="col-span-3 flex items-center justify-center">
                            <span className="text-[9px] mx-1 rounded-full px-2 bg-yellow-300 text-gray-800">
                              In Progress
                            </span>
                          </div>

                          <div className="col-span-3 flex items-center justify-end gap-2">
                            <span className="text-[9px] bg-white border px-2 py-[1px] rounded-full border-orange-400">
                              12 Apr 2026
                            </span>

                            <button
                              type="button"
                              className="h-5 w-5 flex items-center justify-center rounded-full"
                              disabled
                            >
                              <PencilSquareIcon className="h-4 w-4 text-orange-600" />
                            </button>
                          </div>
                        </div>
                      </div>
                      {/* End Action card */}

                    </div>
                    {/* End Action Type block */}

                  </div>
                  {/* End Goal Period block */}

                </div>
                {/* End Goal block */}

              </div>
              {/* End Mission block */}

            </div>
            {/* End Vision block */}

            <p className="text-[10px] text-gray-500">
              This is a mock view of how the action appears under the nested Action Center hierarchy.
            </p>
          </div>
        </div>
      ),
    ];

    const updateSteps = [
      () => (
        <p className="text-sm text-gray-600 leading-6">
          The real power of Actions comes through{" "}
          <span className="font-semibold text-gray-800 bg-orange-100 px-2 rounded-full">
            progress updates
          </span>
          , completion, and target achievement.
        </p>
      ),
      () => (
        <div className="space-y-2">
          <p className="text-sm text-gray-600 leading-6">
            From the{" "}
            <span className="font-semibold text-gray-800 bg-orange-100 px-2 rounded-full">
              Action Center
            </span>
            , locate the action and click the{" "}
            <span className="font-semibold text-gray-800 bg-orange-100 px-2 rounded-full">
              edit
            </span>{" "}
            icon to update its details.
          </p>

          {/* Demo - Action Card with Edit */}
          <div className="mt-2 bg-gray-100 rounded p-2 border border-orange-200">
            <div className="grid grid-cols-12 items-center gap-2">
              
              <div className="col-span-4 flex items-center">
                <div className="h-5 w-5 rounded-full flex justify-center items-center bg-white">
                  <span className="text-orange-600 text-[10px] font-bold">+</span>
                </div>

                <p className="text-xs text-gray-600 font-bold ml-2">1.</p>

                <p className="text-xs font-bold ml-2 text-gray-800">
                  Review top 5 pipeline opportunities
                </p>
              </div>

              <div className="col-span-2">
                <div className="rounded-full bg-gray-300 relative h-3">
                  <div
                    className="rounded-full bg-[#552a9a] h-3"
                    style={{ width: "45%" }}
                  ></div>
                  <p className="text-[8px] absolute top-1/2 left-1/2 -translate-x-1/2 -translate-y-1/2 text-black">
                    45%
                  </p>
                </div>
              </div>

              <div className="col-span-3 flex items-center justify-center">
                <span className="text-[9px] mx-1 rounded-full px-2 bg-yellow-300 text-gray-800">
                  In Progress
                </span>
              </div>

              <div className="col-span-3 flex items-center justify-end gap-2">
                <span className="text-[9px] bg-white border px-2 py-[1px] rounded-full border-orange-400">
                  12 Apr 2026
                </span>

                {/* Highlighted edit icon */}
                <div className="relative">
                  <button
                    type="button"
                    className="h-5 w-5 flex items-center justify-center"
                    disabled
                  >
                    <PencilSquareIcon className="h-4 w-4 text-orange-600" />
                  </button>

                  
                </div>
              </div>

            </div>
          </div>
        </div>
      ),
      () => (
        <p className="text-sm text-gray-600 leading-6">
          You can update fields such as{" "}
          <span className="font-semibold text-gray-800 bg-orange-100 px-2 rounded-full">
            Action Type
          </span>
          ,{" "}
          <span className="font-semibold text-gray-800 bg-orange-100 px-2 rounded-full">
            Action Name
          </span>
          ,{" "}
          <span className="font-semibold text-gray-800 bg-orange-100 px-2 rounded-full">
            Action Description
          </span>
          , and in some cases{" "}
          <span className="font-semibold text-gray-800 bg-orange-100 px-2 rounded-full">
            Target Value
          </span>{" "}
          and{" "}
          <span className="font-semibold text-gray-800 bg-orange-100 px-2 rounded-full">
            Unit of Measure
          </span>
          .
        </p>
      ),
      () => (
        <p className="text-sm text-gray-600 leading-6">
          You may also update assigned users if you have permission. Already assigned users remain preserved after update.
        </p>
      ),
      () => (
        <p className="text-sm text-gray-600 leading-6">
          The{" "}
          <span className="font-semibold text-gray-800 bg-orange-100 px-2 rounded-full">
            Complete By
          </span>{" "}
          date can be changed only if it is not already in the past.
        </p>
      ),
      () => (
        <p className="text-sm text-gray-600 leading-6">
          The{" "}
          <span className="font-semibold text-gray-800 bg-orange-100 px-2 rounded-full">
            Recurrence Pattern
          </span>{" "}
          cannot be changed after creation.
        </p>
      ),
      () => (
        <p className="text-sm text-gray-600 leading-6">
          Recurrence start and end dates can only be adjusted within allowed limits. They cannot be moved into the past, and the end date cannot go beyond the Complete By date.
        </p>
      ),
      () => (
        <div className="space-y-2">
          <p className="text-sm text-gray-600 leading-6">
            For{" "}
            <span className="font-semibold text-gray-800 bg-orange-100 px-2 rounded-full">
              One Time
            </span>{" "}
            actions, go to the Action Center and update the progress note, progress percent, and actual value, then press{" "}
            <span className="font-semibold text-gray-800 bg-orange-100 px-2 rounded-full">
              Save
            </span>
            . An update note is required.
          </p>

          {/* Demo - One Time Action Progress Update */}
          <div className="bg-white border border-gray-200 rounded p-2 space-y-2">

            {/* Note + Progress */}
            <div className="grid grid-cols-2 gap-3">
              <div>
                <p className="font-bold text-xs mb-1 flex items-center">
                  <PlusCircleIcon className="h-4 w-4 text-orange-600 mr-1" />
                  Add a Progress Update Note
                </p>
                <textarea
                  className="w-full rounded text-[10px] border border-gray-300 p-2"
                  placeholder="Add your action note..."
                  disabled
                />
              </div>

              <div>
                <p className="font-bold text-xs mb-1 flex items-center">
                  <ArrowUpCircleIcon className="h-4 w-4 text-orange-600 mr-1" />
                  Update Progress
                </p>
                <div className="flex items-center">
                  <input
                    type="range"
                    min="0"
                    max="100"
                    value="45"
                    className="w-full"
                    disabled
                  />
                  <input
                    type="number"
                    value="45"
                    className="w-12 text-center text-[10px] border mx-1"
                    disabled
                  />
                  <span className="text-xs">%</span>
                </div>
              </div>
            </div>

            {/* Actual / Achieved / Target */}
            <div className="grid grid-cols-3 gap-3 items-center p-2 border bg-orange-100 rounded">
              <div className="flex items-center">
                <p className="text-[10px] mx-1">Actual Value :</p>
                <input
                  type="number"
                  value="18"
                  className="w-14 text-center text-[10px] border"
                  disabled
                />
              </div>

              <div className="flex items-center">
                <p className="text-[10px] mx-1 font-bold text-orange-800">
                  Achieved Till Now :
                </p>
                <p className="text-[10px] mx-1 font-bold text-orange-800">18</p>
              </div>

              <div className="flex items-center">
                <p className="text-[10px] mx-1">Target :</p>
                <p className="text-[10px] mx-1">40</p>
                <p className="text-[10px] mx-1">Conversations</p>
              </div>
            </div>

            {/* Save */}
            <div className="flex justify-end">
              <button
                type="button"
                className="text-white bg-orange-600 rounded-full px-3 py-[2px] text-[10px]"
                disabled
              >
                Save
              </button>
            </div>
          </div>
        </div>
      ),
      () => (
        <div className="space-y-2">
          <p className="text-sm text-gray-600 leading-6">
            For actions with recurrence, you can update progress only for the{" "}
            <span className="font-semibold text-gray-800 bg-orange-100 px-2 rounded-full">
              current recurrence period
            </span>
            .
          </p>

          {/* Demo - Recurring Action Log Trail + Update Section */}
          <div className="bg-white border border-gray-200 rounded p-2 space-y-2">

            {/* Recurrence Log Trail */}
            <div className="bg-gray-300 rounded p-1.5">
              <p className="font-bold text-[10px] m-1">Recurring Action Log Trail:</p>

              <div className="relative bg-gray-50 rounded p-2 my-2">
                <div className="flex overflow-x-auto gap-2 px-1">

                  {/* Past completed */}
                  <div className="w-24 min-w-[4rem] h-24 flex flex-col justify-center items-center rounded text-[9px] bg-lime-600 text-white">
                    <p className="font-bold text-xs">100%</p>
                    <p className="text-[8px]">10 Calls</p>
                    <p className="text-[7px] mt-0.5">Week of 01 Apr</p>
                  </div>

                  {/* Past partial */}
                  <div className="w-24 min-w-[4rem] h-24 flex flex-col justify-center items-center rounded text-[9px] bg-yellow-300 text-black">
                    <p className="font-bold text-xs">60%</p>
                    <p className="text-[8px]">6 Calls</p>
                    <p className="text-[7px] mt-0.5">Week of 08 Apr</p>
                  </div>

                  {/* Current period */}
                  <div className="w-24 min-w-[4rem] h-24 flex flex-col justify-center items-center rounded text-[9px] bg-orange-200 text-black border-2 border-black shadow-md">
                    <p className="font-bold text-xs">0%</p>
                    <p className="text-[8px]">0 Calls</p>
                    <p className="text-[7px]">Week of 15 Apr </p>
                    <p className="text-[7px] font-semibold bg-white rounded-full px-3">
                      Current
                    </p>
                  </div>

                  {/* Future */}
                  <div className="w-24 min-w-[4rem] h-24 flex flex-col justify-center items-center rounded text-[9px] bg-gray-200 text-black">
                    <p className="text-center font-semibold text-[8px]">To be logged</p>
                    <p className="text-[7px] mt-0.5">Week of 22 Apr</p>
                    <p className="text-[7px] mt-0.5 text-gray-600 bg-orange-100 rounded-full px-1">
                      Opens 22 Apr
                    </p>
                  </div>

                </div>
              </div>
            </div>

            {/* Current Period Progress Update */}
            <div className="bg-white p-1.5 rounded">

              <div className="grid grid-cols-2 gap-2">
                
                {/* Note */}
                <div>
                  <p className="font-bold text-[10px] mb-1 flex items-center">
                    <PlusCircleIcon className="h-4 w-4 text-orange-600 mr-1" />
                    Add current period Progress Update Note
                  </p>
                  <textarea
                    className="w-full rounded text-[9px] border border-gray-300 p-1.5"
                    placeholder="Add your note..."
                    disabled
                  />
                </div>

                {/* Progress */}
                <div>
                  <p className="font-bold text-[10px] mb-1 flex items-center">
                    <ArrowUpCircleIcon className="h-4 w-4 text-orange-600 mr-1" />
                    Update current period’s Log Progress
                  </p>
                  <div className="flex items-center">
                    <input
                      type="range"
                      min="0"
                      max="100"
                      value="40"
                      className="w-full"
                      disabled
                    />
                    <input
                      type="number"
                      value="40"
                      className="w-10 text-center text-[9px] border mx-1"
                      disabled
                    />
                    <span className="text-[9px]">%</span>
                  </div>
                </div>
              </div>

              {/* Actual / Achieved / Target */}
              <div className="grid grid-cols-3 gap-2 items-center mt-1 p-1.5 border bg-orange-100 rounded">
                
                <div className="col-span-1 flex items-center">
                  <p className="text-[8px] mx-1">Actual Value (This Period):</p>
                  <input
                    type="number"
                    value="4"
                    className="w-12 text-center text-[9px] border"
                    disabled
                  />
                </div>

                <div className="col-span-1 flex items-center">
                  <p className="text-[8px] mx-1 font-bold text-orange-800">
                    Achieved Value (Till Now):
                  </p>
                  <p className="text-[9px] mx-1 font-bold text-orange-800">16</p>
                </div>

                <div className="col-span-1 flex items-center">
                  <p className="text-[8px] mx-1">Target:</p>
                  <p className="text-[9px] mx-1">20</p>
                  <p className="text-[9px] mx-1">Calls</p>
                </div>

              </div>

              {/* Save */}
              <div className="flex justify-end mt-1">
                <button
                  type="button"
                  className="text-white bg-orange-600 rounded-full px-2 py-[1px] text-[8px]"
                  disabled
                >
                  Save
                </button>
              </div>

            </div>
          </div>
        </div>
      ),
      () => (
        <div className="space-y-2">
          <p className="text-sm text-gray-600 leading-6">
            If the current period is marked{" "}
            <span className="font-semibold text-gray-800 bg-orange-100 px-2 rounded-full">
              100%
            </span>
            , that recurrence card is considered closed and cannot be edited further.
          </p>

          {/* Demo - Completed recurring log message */}
          <div className="mt-2 p-2 rounded bg-lime-100 border border-lime-300 text-xs text-gray-800">
            <p className="mb-1">
              ✅ You have completed{" "}
              <span className="bg-yellow-100 rounded-full px-2 font-bold border">
                current period&apos;s
              </span>{" "}
              log.
            </p>
            <p>
              Please revisit this section on{" "}
              <span className="font-semibold">22 Apr 2026</span>.
            </p>
          </div>
        </div>
      ),
      () => (
        <div className="space-y-2">
          <p className="text-sm text-gray-600 leading-6">
            Keep updating your actions consistently so that progress becomes visible across your mission backbone over time.
          </p>

          {/* Demo - Mission backbone roll up */}
          <div className="bg-orange-50 border border-orange-200 rounded p-2">
            <div className="grid grid-cols-12 items-center gap-3">
              
              <div className="col-span-7 flex items-center">
                {/* <span className="text-orange-600 text-xs font-bold">−</span> */}
                <span className="ml-2 text-orange-600 text-[10px] font-bold">Mission :</span>
                <span className="ml-2 text-[10px] font-semibold text-gray-800">
                  {/* Improve quality of strategic deal pursuit */}
                  Deepen Strategic Client Influence
                </span>
              </div>

              <div className="col-span-5 grid grid-cols-4 items-center gap-3 text-[10px]">
                
                {/* Achieved % */}
                <div className="w-10 h-10 flex items-center justify-center">
                  <CircularProgressbar
                    value={68}
                    text={`68%`}
                    styles={buildStyles({
                      textSize: "26px",
                      pathColor: "#ea580c",
                      textColor: "#374151",
                      trailColor: "#e5e7eb",
                    })}
                  />
                </div>

                {/* Numbers Grid */}
                <div className="col-span-3 grid grid-cols-3 justify-start items-start gap-x-4">
                  <div>
                    <p className="text-gray-500 text-[9px]">Actuals</p>
                    <div className="mt-1 space-y-0.5">
                      <div className="flex items-center">
                        <span className="text-orange-600 mr-1">All:</span>
                        <span className="font-semibold">34</span>
                      </div>
                      <div className="flex items-center">
                        <span className="text-orange-600 mr-1">Self:</span>
                        <span className="font-semibold">18</span>
                      </div>
                    </div>
                  </div>

                  <div>
                    <p className="text-gray-500 text-[9px]">Target</p>
                    <p className="font-semibold mt-1">50</p>
                  </div>

                  <div>
                    <p className="text-gray-500 text-[9px]">UoM</p>
                    <p className="font-semibold mt-1">Calls</p>
                  </div>
                </div>
              </div>
            </div>

            <p className="text-[10px] text-gray-500 mt-2">
              Outcome based actions roll up into mission progress over time.
            </p>
          </div>
        </div>
      ),
    ];

    // 31 Mar 2026
    const renderNumberedSteps = (steps) => (
      <div className="space-y-3">
        {steps.map((StepComp, index) => (
          <div key={`action-guide-step-${index}`} className="flex items-start">
            <div className="h-6 w-6 min-w-[1.5rem] min-h-[1.5rem] rounded-full bg-orange-100 text-orange-700 text-[11px] font-semibold flex items-center justify-center mt-0.5 flex-shrink-0">
              {index + 1}
            </div>
            <div className="ml-3 flex-1 text-sm text-gray-600 leading-6 text-left">
              {typeof StepComp === "function" ? <StepComp /> : StepComp}
            </div>
          </div>
        ))}
      </div>
    );

    // const renderNumberedSteps = (steps) => (
    //   <div className="space-y-2">
    //     {steps.map((StepComp, index) => {
    //       const isFullComponent = StepComp?.name === "ActionGuidingTabs";

    //       if (isFullComponent) {
    //         return (
    //           <div key={`action-guide-step-${index}`}>
    //             <StepComp />
    //           </div>
    //         );
    //       }

    //       return (
    //         <div key={`action-guide-step-${index}`} className="flex items-start">
    //           <div className="h-5 w-5 rounded-full bg-orange-100 text-orange-700 text-[11px] flex items-center justify-center mt-0.5">
    //             {index + 1}
    //           </div>
    //           <div className="ml-2 text-sm text-gray-600 leading-6">
    //             <StepComp />
    //           </div>
    //         </div>
    //       );
    //     })}
    //   </div>
    // );

    return (
      <div className="space-y-3">
        <div className="flex space-x-2 border-b border-gray-200 pb-2">
          {[
            { key: "create", label: "Create" },
            { key: "update", label: "Update" },
          ]?.map((tab) => (
            <button
              key={tab.key}
              onClick={() => setActiveActionGuideTab(tab.key)}
              className={`text-xs px-3 py-1 rounded-full border font-semibold ${
                activeActionGuideTab === tab.key
                  ? "bg-orange-600 text-white border-orange-600"
                  : "bg-white text-gray-600 border-gray-200"
              }`}
            >
              {tab.label}
            </button>
          ))}
        </div>

        {activeActionGuideTab === "create" && renderNumberedSteps(createSteps)}
        {activeActionGuideTab === "update" && renderNumberedSteps(updateSteps)}
      </div>
    );
  };

  const beginItems = [
    {
      id: "morning",
      title: "Morning",
      // subtitle: "Energization",
      subtitle: "Unlock your routine", // 02 Apr 2026
      // desc: "Begin by energizing yourself so that your day starts with greater readiness and intent.",
      desc: "Energize to start your day with greater readiness and intent.",
      // 26 Mar 2026
      navigationPath: [
        () => (
          <p className="text-sm text-gray-600 leading-6">
            Click on the{" "}
            <span className="inline-flex items-center px-2 py-0.5 rounded-full bg-gray-100 border border-gray-200 text-gray-800 font-semibold text-xs">
              Power up!
            </span>{" "}
            button, next to the <span className="inline-flex items-center px-2 py-0.5 rounded-full bg-gray-100 border border-gray-200 text-gray-800 font-semibold text-xs">Board!</span> button.
          </p>
        ),
        () => (
          <p className="text-sm text-gray-600 leading-6">
            Click on the{" "}
            <span className="inline-flex items-center px-2 py-0.5 rounded-full bg-gray-100 border border-gray-200 text-gray-800 font-semibold text-xs">
              All
            </span>{" "}
            chip on the Power Up bar items.
          </p>
        ),
        () => (
          <p className="text-sm text-gray-600 leading-6">
            Under the{" "}
            <span className="inline-flex items-center px-2 py-0.5 rounded-full bg-orange-100 border border-orange-200 text-orange-800 font-semibold text-xs">
              Morning
            </span>{" "}
            segment, click{" "}
            <span className="font-semibold text-gray-800 bg-orange-100 px-2 rounded-full">
              2. Stay energized with morning habits
            </span>
            .
          </p>
        ),
      ],
      // 27 Mar 2026
      guidingSteps: [
        () => (
          <p className="text-sm text-gray-600 leading-6">
            There are{" "}
            <span className="inline-flex items-center px-2 py-0.5 rounded-full bg-orange-100 border border-orange-200 text-orange-800 font-semibold text-xs">
              5 core morning habits
            </span>{" "}
            connected to{" "}
            <span className="inline-flex items-center px-2 py-0.5 rounded-full bg-gray-100 border border-gray-200 text-gray-800 font-semibold text-xs">
              5 human energy plexuses
            </span>
            .
          </p>
        ),
        () => (
          <p className="text-sm text-gray-600 leading-6">
            Each habit is connected to{" "}
            <span className="font-semibold text-gray-800 bg-orange-100 px-2 rounded-full">
              activating a plexus
            </span>
            .
          </p>
        ),
        () => (
          <p className="text-sm text-gray-600 leading-6">
            Click on the{" "}
            <span className="inline-flex items-center px-2 py-0.5 rounded-full bg-gray-100 border border-gray-200 text-gray-800 font-semibold text-xs">
              Today
            </span>{" "}
            time chip and then go to the{" "}
            <span className="inline-flex items-center px-2 py-0.5 rounded-full bg-orange-100 border border-orange-200 text-orange-800 font-semibold text-xs">
              Log View
            </span>
            .
          </p>
        ),
        () => (
          <p className="text-sm text-gray-600 leading-6">
            Log each habit with a{" "}
            <span className="font-semibold text-gray-800 bg-orange-100 px-2 rounded-full">
              comment
            </span>{" "}
            if you can. It is recommended, but not required.
          </p>
        ),
        () => (
          <p className="text-sm text-gray-600 leading-6">
            You can change the{" "}
            <span className="inline-flex items-center px-2 py-0.5 rounded-full bg-gray-100 border border-gray-200 text-gray-800 font-semibold text-xs">
              time
            </span>{" "}
            based on when you actually performed the habit.
          </p>
        ),
        () => (
          <p className="text-sm text-gray-600 leading-6">
            You can log a habit{" "}
            <span className="font-semibold text-gray-800 bg-orange-100 px-2 rounded-full">
              only once
            </span>{" "}
            and only for{" "}
            <span className="inline-flex items-center px-2 py-0.5 rounded-full bg-gray-100 border border-gray-200 text-gray-800 font-semibold text-xs">
              Today
            </span>
            . This is deliberate, so you build an everyday logging rhythm.
          </p>
        ),
        () => (
          <p className="text-sm text-gray-600 leading-6">
            If you did not log it, you{" "}
            <span className="font-semibold text-red-700 bg-red-50 px-2 rounded-full">
              lose your streak
            </span>
            .
          </p>
        ),
        () => (
          <p className="text-sm text-gray-600 leading-6">
            See your{" "}
            <span className="font-semibold text-gray-800 bg-orange-100 px-2 rounded-full">
              streak grow
            </span>{" "}
            and refine your habits to become more consistent.
          </p>
        ),
      ],
      // guidingSteps: [
      //   "There are 5 core morning habits connected to 5 core human energy plexuses",
      //   "Each habit is connected to activating a plexus",
      //   "Go to the Log View after clicking Today as the timechip", 
      //   "Log each habit with a comment (recommended but not required)",
      //   "You can change the time based on when you actually performed that habit",
      //   "You can log the habit only once and only for Today. This is deliberate for you to form a logging habit everyday",
      //   "If you didn't log it, you lost your streak!",
      //   "See your streak grow and refine your habits to become more consistent"
      // ],
      
      visualType: "Streak View",
      visualDesc: "See your streak build as your rhythm becomes consistent.",
      Icon: SunIcon,
    },
    {
      id: "reflections",
      title: "Reflections",
      // subtitle: "Thinking Clarity",
      subtitle: "Unlock your intellect", // 02 Apr 2026
      // desc: "Pause and think more clearly about what you are seeing and shaping.",
      desc: "Start building and growing your thought leadership.",
      // 26 Mar 2026
      navigationPath: [
        () => (
          <p className="text-sm text-gray-600 leading-6">
            Click on the{" "}
            <span className="inline-flex items-center px-2 py-0.5 rounded-full bg-gray-100 border border-gray-200 text-gray-800 font-semibold text-xs">
              Power up!
            </span>{" "}
            button, next to the <span className="inline-flex items-center px-2 py-0.5 rounded-full bg-gray-100 border border-gray-200 text-gray-800 font-semibold text-xs">Board!</span> button.
          </p>
        ),
        () => (
          <p className="text-sm text-gray-600 leading-6">
            Click on the{" "}
            <span className="inline-flex items-center px-2 py-0.5 rounded-full bg-gray-100 border border-gray-200 text-gray-800 font-semibold text-xs">
              Reflections
            </span>{" "}
            chip on the Power up bar items.
          </p>
        ),
        () => (
          <p className="text-sm text-gray-600 leading-6">
            Scroll till you see{" "}
            <span className="inline-flex items-center gap-1 font-bold">
              Add a reflection
              <PlusIcon className="h-4 w-4 text-white p-0.5 rounded bg-lime-600 hover:bg-green-600" />
            </span>
            {" "}. Click on the + button.
          </p>
        ),
      ],
      // 29 Mar 2026
      guidingSteps: [
        () => (
          <p className="text-sm text-gray-600 leading-6">
            <span className="inline-flex items-center px-2 py-0.5 rounded-full bg-orange-100 border border-orange-200 text-orange-800 font-semibold text-xs">
              Reflections
            </span>{" "}
            are the starting points for building a{" "}
            <span className="font-semibold text-gray-800 bg-orange-100 px-2 rounded-full">
              thought leadership profile
            </span>
            .
          </p>
        ),
        () => (
          <p className="text-sm text-gray-600 leading-6">
            They are best done when it is a bit{" "}
            <span className="inline-flex items-center px-2 py-0.5 rounded-full bg-gray-100 border border-gray-200 text-gray-800 font-semibold text-xs">
              quiet
            </span>{" "}
            around you.{" "}
            <span className="font-semibold text-gray-800 bg-orange-100 px-2 rounded-full">
              Early mornings
            </span>{" "}
            are usually best for this.
          </p>
        ),
        () => (
          <p className="text-sm text-gray-600 leading-6">
            You can start with a simple reflection around your{" "}
            <span className="font-semibold text-gray-800 bg-orange-100 px-2 rounded-full">
              key activities from the prior day
            </span>
            .
          </p>
        ),
        () => (
          <p className="text-sm text-gray-600 leading-6">
            You can then layer it with further thoughtful deliberation around any other{" "}
            <span className="inline-flex items-center px-2 py-0.5 rounded-full bg-gray-100 border border-gray-200 text-gray-800 font-semibold text-xs">
              observation
            </span>{" "}
            or{" "}
            <span className="inline-flex items-center px-2 py-0.5 rounded-full bg-gray-100 border border-gray-200 text-gray-800 font-semibold text-xs">
              thought
            </span>{" "}
            which may be on your mind.
          </p>
        ),
        () => (
          <p className="text-sm text-gray-600 leading-6">
            Write as{" "}
            <span className="font-semibold text-gray-800 bg-orange-100 px-2 rounded-full">
              freely
            </span>{" "}
            as you can, without worrying about coherence or perfection.
          </p>
        ),
        () => (
          <p className="text-sm text-gray-600 leading-6">
            Once you have written it, you can then{" "}
            <span className="font-semibold text-gray-800 bg-orange-100 px-2 rounded-full">
              review and refine
            </span>{" "}
            it.
          </p>
        ),
        () => (
          <p className="text-sm text-gray-600 leading-6">
            Do not use{" "}
            <span className="font-semibold text-red-700 bg-red-50 px-2 rounded-full">
              AI
            </span>{" "}
            to write it. Write in your own words and sentences.
          </p>
        ),
        () => (
          <p className="text-sm text-gray-600 leading-6">
            Try doing it around the{" "}
            <span className="inline-flex items-center px-2 py-0.5 rounded-full bg-gray-100 border border-gray-200 text-gray-800 font-semibold text-xs">
              same time
            </span>{" "}
            as much as possible.
          </p>
        ),
        () => (
          <p className="text-sm text-gray-600 leading-6">
            Try doing it{" "}
            <span className="font-semibold text-gray-800 bg-orange-100 px-2 rounded-full">
              once everyday
            </span>{" "}
            if possible. The idea is to build consistency and form it as a habit. Do not worry about the quality in the beginning. Just get in and write.
          </p>
        ),
        () => (
          <p className="text-sm text-gray-600 leading-6">
            See your{" "}
            <span className="font-semibold text-gray-800 bg-orange-100 px-2 rounded-full">
              streak grow
            </span>{" "}
            and refine your reflections through further deliberation. You may also share and discuss them with your trusted cohort for inputs to enrich them.
          </p>
        ),
      ],
      // guidingSteps: [
      //   "Pause and reflect",
      //   "Capture key insight",
      //   "Build thinking clarity",
      // ],
      visualType: "Streak / Cumulative",
      visualDesc: "Watch your reflection streak and entries grow.",
      Icon: EtWabReflectionIcon1SVGComp,
    },
    {
      id: "conversations",
      title: "Conversations",
      // subtitle: "Engagement Muscle",
      subtitle: "Unlock your presence", // 02 Apr 2026
      desc: "Strengthen how you engage through more intentional interactions.",
      // 26 Mar 2026
      navigationPath: [
        () => (
          <p className="text-sm text-gray-600 leading-6">
            Click on the{" "}
            <span className="inline-flex items-center px-2 py-0.5 rounded-full bg-gray-100 border border-gray-200 text-gray-800 font-semibold text-xs">
              Power up!
            </span>{" "}
            button, next to the <span className="inline-flex items-center px-2 py-0.5 rounded-full bg-gray-100 border border-gray-200 text-gray-800 font-semibold text-xs">Board!</span> button.
          </p>
        ),
        () => (
          <p className="text-sm text-gray-600 leading-6">
            Click on the{" "}
            <span className="inline-flex items-center px-2 py-0.5 rounded-full bg-gray-100 border border-gray-200 text-gray-800 font-semibold text-xs">
              Conversations
            </span>{" "}
            chip on the Power up bar items.
          </p>
        ),
        () => (
          <p className="text-sm text-gray-600 leading-6">
            Scroll till you see{" "}
            <span className="inline-flex items-center gap-1 font-bold">
              Add a conversation
              <PlusIcon className="h-4 w-4 text-white p-0.5 rounded bg-lime-600 hover:bg-green-600" />
            </span>
            {" "}. Click on the + button.
          </p>
        ),
      ],
      // 29 Mar 2026
      guidingSteps: [
        () => (
          <p className="text-sm text-gray-600 leading-6">
            <span className="inline-flex items-center px-2 py-0.5 rounded-full bg-orange-100 border border-orange-200 text-orange-800 font-semibold text-xs">
              Conversations
            </span>{" "}
            test your{" "}
            <span className="font-semibold text-gray-800 bg-orange-100 px-2 rounded-full">
              thought leadership
            </span>
            , your intellect, and your ability to engage stakeholders in an inspiring way.
          </p>
        ),
        () => (
          <p className="text-sm text-gray-600 leading-6">
            They are not about making an impression, but about building{" "}
            <span className="font-semibold text-gray-800 bg-orange-100 px-2 rounded-full">
              influence and trust
            </span>
            .
          </p>
        ),
        () => (
          <p className="text-sm text-gray-600 leading-6">
            You can capture a conversation{" "}
            <span className="inline-flex items-center px-2 py-0.5 rounded-full bg-gray-100 border border-gray-200 text-gray-800 font-semibold text-xs">
              for yourself
            </span>{" "}
            or for a{" "}
            <span className="inline-flex items-center px-2 py-0.5 rounded-full bg-gray-100 border border-gray-200 text-gray-800 font-semibold text-xs">
              specific contact
            </span>
            , which is more common and easier to begin with.
          </p>
        ),
        () => (
          <p className="text-sm text-gray-600 leading-6">
            You can also capture conversations during{" "}
            <span className="font-semibold text-gray-800 bg-orange-100 px-2 rounded-full">
              Eternity trail sessions
            </span>{" "}
            such as Induction sessions.
          </p>
        ),
        () => (
          <p className="text-sm text-gray-600 leading-6">
            The best time to capture a conversation is{" "}
            <span className="font-semibold text-gray-800 bg-orange-100 px-2 rounded-full">
              during the conversation
            </span>{" "}
            by taking notes as much as you can.
          </p>
        ),
        () => (
          <p className="text-sm text-gray-600 leading-6">
            Then immediately after,{" "}
            <span className="font-semibold text-gray-800 bg-orange-100 px-2 rounded-full">
              elaborate further
            </span>{" "}
            based on your observations, key moments, opportunity and risk signals, and next steps.
          </p>
        ),
        () => (
          <p className="text-sm text-gray-600 leading-6">
            To build a habit,{" "}
            <span className="inline-flex items-center px-2 py-0.5 rounded-full bg-gray-100 border border-gray-200 text-gray-800 font-semibold text-xs">
              Trinity time nudges
            </span>{" "}
            prompt you during the mid or later part of the day once the morning rush settles.
          </p>
        ),
        () => (
          <p className="text-sm text-gray-600 leading-6">
            Capture the conversation in your{" "}
            <span className="font-semibold text-gray-800 bg-orange-100 px-2 rounded-full">
              own words and voice
            </span>
            , instead of copying an AI transcript. You internalize it better this way.
          </p>
        ),
        () => (
          <p className="text-sm text-gray-600 leading-6">
            Try capturing all conversations of the day{" "}
            <span className="font-semibold text-gray-800 bg-orange-100 px-2 rounded-full">
              on the same day
            </span>{" "}
            or at most a day later.
          </p>
        ),
        () => (
          <p className="text-sm text-gray-600 leading-6">
            See your{" "}
            <span className="font-semibold text-gray-800 bg-orange-100 px-2 rounded-full">
              streak grow
            </span>{" "}
            and refine your captured conversations through further deliberation. Refer to them before your next conversation with the same contact.
          </p>
        ),
      ],
      // guidingSteps: [
      //   "Notice key conversations",
      //   "Capture what mattered",
      //   "Build engagement awareness",
      // ],
      visualType: "Cumulative View",
      visualDesc: "See your conversation entries accumulate.",
      Icon: EtWabConversationIcon1SVGComp,
    },
    {
      id: "creations",
      title: "Creations",
      // subtitle: "Original Output",
      subtitle: "Unlock your creative horsepower", // 02 Apr 2026
      desc: "Shape ideas into visible outputs that move growth forward.",
      // 26 Mar 2026
      navigationPath: [
        () => (
          <p className="text-sm text-gray-600 leading-6">
            Click on the{" "}
            <span className="inline-flex items-center px-2 py-0.5 rounded-full bg-gray-100 border border-gray-200 text-gray-800 font-semibold text-xs">
              Power up!
            </span>{" "}
            button, next to the <span className="inline-flex items-center px-2 py-0.5 rounded-full bg-gray-100 border border-gray-200 text-gray-800 font-semibold text-xs">Board!</span> button.
          </p>
        ),
        () => (
          <p className="text-sm text-gray-600 leading-6">
            Click on the{" "}
            <span className="inline-flex items-center px-2 py-0.5 rounded-full bg-gray-100 border border-gray-200 text-gray-800 font-semibold text-xs">
              Creations
            </span>{" "}
            chip on the Power up bar items.
          </p>
        ),
        () => (
          <p className="text-sm text-gray-600 leading-6">
            Scroll till you see{" "}
            <span className="inline-flex items-center gap-1 font-bold">
              Add a creation
              <PlusIcon className="h-4 w-4 text-white p-0.5 rounded bg-lime-600 hover:bg-green-600" />
            </span>
            {" "}. Click on the + button.
          </p>
        ),
      ],
      // 29 Mar 2026
      guidingSteps: [
        () => (
          <p className="text-sm text-gray-600 leading-6">
            <span className="inline-flex items-center px-2 py-0.5 rounded-full bg-orange-100 border border-orange-200 text-orange-800 font-semibold text-xs">
              Creations
            </span>{" "}
            are the defining and lasting proof of your{" "}
            <span className="font-semibold text-gray-800 bg-orange-100 px-2 rounded-full">
              thought leadership
            </span>{" "}
            and how much of your potential is unlocked.
          </p>
        ),
        () => (
          <p className="text-sm text-gray-600 leading-6">
            They help you build{" "}
            <span className="font-semibold text-gray-800 bg-orange-100 px-2 rounded-full">
              influence, trust and followership
            </span>
            , and form your legacy, keeping you relevant even beyond your physical presence.
          </p>
        ),
        () => (
          <p className="text-sm text-gray-600 leading-6">
            You can think about a creation by visiting your{" "}
            <span className="inline-flex items-center px-2 py-0.5 rounded-full bg-gray-100 border border-gray-200 text-gray-800 font-semibold text-xs">
              Reflections
            </span>{" "}
            or{" "}
            <span className="inline-flex items-center px-2 py-0.5 rounded-full bg-gray-100 border border-gray-200 text-gray-800 font-semibold text-xs">
              Conversations
            </span>{" "}
            and using it as a basis for starting an{" "}
            <span className="font-semibold text-gray-800 bg-orange-100 px-2 rounded-full">
              Article or Blog
            </span>
            .
          </p>
        ),
        () => (
          <p className="text-sm text-gray-600 leading-6">
            Trinity offers{" "}
            <span className="font-semibold text-gray-800 bg-orange-100 px-2 rounded-full">
              multiple creation types and focus areas
            </span>{" "}
            across industries to organize your work.
          </p>
        ),
        () => (
          <div className="space-y-2">
            <p className="text-sm text-gray-600 leading-6">
              Add a short and clear{" "}
              <span className="font-semibold text-gray-800 bg-orange-100 px-2 rounded-full">
                Creation Name
              </span>{" "}
              to anchor your idea.
            </p>

            {/* Demo - Creation Name Field */}
            <div className="bg-gray-50 border border-gray-200 rounded p-2">
              <label className="block text-gray-600 text-xs font-bold mb-1">
                Creation Name
              </label>
              <input
                type="text"
                placeholder="Enter a creation name or title"
                className="w-full rounded p-2 text-xs border border-gray-300 focus:ring-orange-500 focus:border-orange-500"
                disabled
              />
            </div>
          </div>
        ),
        () => (
          <div className="space-y-2">
            <p className="text-sm text-gray-600 leading-6">
              Select{" "}
              <span className="inline-flex items-center px-2 py-0.5 rounded-full bg-gray-100 border border-gray-200 text-gray-800 font-semibold text-xs">
                Creation Type
              </span>{" "}
              as{" "}
              <span className="font-semibold text-gray-800 bg-orange-100 px-2 rounded-full">
                Articles & Blogs
              </span>
              .
            </p>

            {/* Demo - Creation Type Field */}
            <div className="bg-gray-50 border border-gray-200 rounded p-2">
              <label className="block text-gray-600 text-xs font-bold mb-1">
                Creation Type
              </label>
              <select
                className="w-full rounded p-2 text-xs border border-gray-300 focus:ring-orange-500 focus:border-orange-500"
                disabled
                value="articlesBlogs"
              >
                <option value="articlesBlogs">Articles & Blogs</option>
              </select>
            </div>
          </div>
        ),
        () => (
          <div className="space-y-2">
            <p className="text-sm text-gray-600 leading-6">
              Use{" "}
              <span className="font-semibold text-gray-800 bg-orange-100 px-2 rounded-full">
                Creation Focus Area
              </span>{" "}
              to categorize your creation. Click{" "}
              <span className="font-bold">Add </span>
              <button
                  type="button"
                  className="bg-lime-600 text-white text-xs font-bold px-2 py-0.5 rounded mx-1"
                  disabled
                >
                  +
                </button>
              to select an Area Type or leave it as{" "}
              <span className="inline-flex items-center px-2 py-0.5 rounded-full bg-gray-100 border border-gray-200 text-gray-800 font-semibold text-xs">
                General
              </span>{" "}
              and refine later.
            </p>

            {/* Demo - Creation Focus Area */}
            <div className="bg-gray-50 border border-gray-200 rounded p-2">
              <div className="flex justify-between items-center mb-1">
                <p className="text-xs font-bold text-gray-700">
                  Creation Focus Areas
                </p>
                <button
                  type="button"
                  className="bg-lime-600 text-white text-xs font-bold px-2 py-0.5 rounded"
                  disabled
                >
                  +
                </button>
              </div>

              {/* Sample focus area row */}
              <div className="bg-white border border-gray-200 rounded p-2 space-y-1">
                <div className="flex justify-between items-center">
                  <p className="text-[10px] font-semibold text-gray-600">
                    Area Type
                  </p>
                  <select
                    className="w-1/2 text-[10px] rounded p-1 border border-gray-300"
                    disabled
                  >
                    <option>Industry</option>
                  </select>
                </div>

                <div className="flex justify-between items-center">
                  <p className="text-[10px] font-semibold text-gray-600">
                    Specific Industry
                  </p>
                  <select
                    className="w-1/2 text-[10px] rounded p-1 border border-gray-300"
                    disabled
                  >
                    <option>Technology</option>
                  </select>
                </div>
              </div>

              <p className="text-[10px] text-gray-400 mt-1">
                You can add multiple focus areas or leave this blank for General.
              </p>
            </div>
          </div>
        ),
        () => (
          <div className="space-y-2">
            <p className="text-sm text-gray-600 leading-6">
              Enter your actual content in{" "}
              <span className="font-semibold text-gray-800 bg-orange-100 px-2 rounded-full">
                Creation Description
              </span>
              .
            </p>

            {/* Demo - Creation Description */}
            <div className="bg-gray-50 border border-gray-200 rounded p-2">
              <label className="block text-gray-600 text-xs font-bold mb-1">
                Creation Description
              </label>

              <div className="w-full min-h-[110px] rounded border border-gray-300 bg-white p-3">
                <p className="text-xs text-gray-400">
                  Write your creation description here...
                </p>
              </div>
            </div>
          </div>
        ),
        () => (
          <div className="space-y-2">
            <p className="text-sm text-gray-600 leading-6">
              Use{" "}
              <span className="font-semibold text-gray-800 bg-orange-100 px-2 rounded-full">
                Creation Note
              </span>{" "}
              for supporting context such as anecdotes, references or process notes.
            </p>

            {/* Demo - Creation Notes */}
            <div className="bg-gray-50 border border-gray-200 rounded p-2">
              <div className="flex justify-between items-center mb-2">
                <p className="text-xs font-bold text-gray-700">Creation Notes</p>
                <button
                  type="button"
                  className="bg-lime-600 text-white text-xs font-bold px-2 py-0.5 rounded"
                  disabled
                >
                  +
                </button>
              </div>

              <div className="p-2 border rounded bg-white">
                <div className="flex justify-between items-center mb-2">
                  <p className="text-xs font-bold text-gray-700">Note 1</p>
                  <button
                    type="button"
                    className="bg-red-500 text-white text-xs font-bold px-2 py-0.5 rounded"
                    disabled
                  >
                    -
                  </button>
                </div>

                <div className="bg-gray-50 border border-gray-200 rounded p-2">
                  <label className="block text-gray-600 text-xs font-bold mb-1">
                    Note Text
                  </label>

                  <div className="w-full min-h-[90px] rounded border border-gray-300 bg-white p-3">
                    <p className="text-xs text-gray-400">
                      Write your note here...
                    </p>
                  </div>

                  <p className="text-[10px] text-gray-400 mt-2">
                    Created on: 29 Mar 2026
                  </p>
                </div>
              </div>
            </div>
          </div>
        ),
        () => (
          <div className="space-y-2">
            <p className="text-sm text-gray-600 leading-6">
              You may mark a creation as a{" "}
              <span className="font-semibold text-purple-700 bg-purple-50 px-2 rounded-full">
                Magic Moment
              </span>
              . This cannot be undone, so choose thoughtfully.
            </p>

            {/* Demo - Magic Moment */}
            <div className="bg-gray-50 border border-gray-200 rounded p-2">
              <div className="flex items-center">
                <input
                  type="checkbox"
                  className="mr-2"
                  disabled
                />
                <label className="text-xs text-gray-600">
                  Mark as a Magic Moment
                </label>
              </div>

              <p className="text-[10px] text-gray-400 mt-2">
                Once marked, this cannot be undone.
              </p>
            </div>
          </div>
        ),
        () => (
          <p className="text-sm text-gray-600 leading-6">
            Click{" "}
            <span className="font-semibold text-gray-800 bg-orange-100 px-2 rounded-full">
              Create
            </span>{" "}
            or{" "}
            <span className="font-semibold text-gray-800 bg-orange-100 px-2 rounded-full">
              Update
            </span>{" "}
            to capture or refine your creation.
          </p>
        ),
        () => (
          <p className="text-sm text-gray-600 leading-6">
            See your{" "}
            <span className="font-semibold text-gray-800 bg-orange-100 px-2 rounded-full">
              streak grow
            </span>{" "}
            and keep refining your creation so it stays live and relevant over time.
          </p>
        ),
      ],
      // guidingSteps: [
      //   "Capture ideas",
      //   "Shape into outputs",
      //   "Build consistency",
      // ],
      visualType: "Cumulative View",
      visualDesc: "Track how your output builds over time.",
      Icon: EtWabCreationIcon1SVGComp,
    },
    {
      id: "actions",
      title: "Actions",
      // subtitle: "Forward Movement",
       // desc: "Translate priorities into visible movement.",
      subtitle: "Unlock your performance", // 02 Apr 2026
      desc: "Make every action count for your missions", // 02 Apr 2026
      // 27 Mar 2026
      navigationPath: [
        () => (
          <p className="text-sm text-gray-600 leading-6">
            Click on the{" "}
            <span className="inline-flex items-center px-2 py-0.5 rounded-full bg-gray-100 border border-gray-200 text-gray-800 font-semibold text-xs">
              Power up!
            </span>{" "}
            button, next to the <span className="inline-flex items-center px-2 py-0.5 rounded-full bg-gray-100 border border-gray-200 text-gray-800 font-semibold text-xs">Board!</span> button.
          </p>
        ),
        () => (
          <p className="text-sm text-gray-600 leading-6">
            Click on the{" "}
            <span className="inline-flex items-center px-2 py-0.5 rounded-full bg-gray-100 border border-gray-200 text-gray-800 font-semibold text-xs">
              Actions
            </span>{" "}
            chip on the Power up bar items.
          </p>
        ),
        () => (
          <p className="text-sm text-gray-600 leading-6">
            Scroll till you see{" "}
            <span className="inline-flex items-center gap-1 font-bold">
              Add an Action
              <PlusIcon className="h-4 w-4 text-white p-0.5 rounded bg-lime-600 hover:bg-green-600" />
            </span>
            {" "}. Click on the + button.
          </p>
        ),
      ],
      // 30 Mar 2026
      guidingSteps: [
        () => <ActionGuidingTabs />,
      ],

      // guidingSteps: [
      //   "Pick one priority",
      //   "Update progress",
      //   "Build momentum",
      // ],
      // visualType: "Progress View",
      // visualDesc: "See your movement and progress accumulate.",
      Icon: EtWabActionIcon1SVGComp,
    },
  ];

  return (
    <div className="space-y-4">
      {/* 1️⃣ Opening narrative */}
      <div className="bg-orange-50 border border-orange-100 rounded p-4">
        <p className="text-lg font-bold text-gray-800">Where to Begin</p>

        <div className="mt-3 space-y-2">
          <p className="text-sm text-gray-700 leading-6">
            Begin by building a few core habits with consistency.
          </p>
          <p className="text-sm text-gray-700 leading-6">
            Start with energization, then exercise your thinking and action muscles.
          </p>
        </div>
      </div>

      {/* 2️⃣ Core habits */}
      <div>
        <p className="text-lg font-bold text-gray-800">Build the Core Habits</p>
        <p className="text-sm text-gray-600 mt-1">
          Start simple. Build rhythm first, then momentum.
        </p>

        <div className="mt-3 grid grid-cols-1 md:grid-cols-2 xl:grid-cols-2 gap-4">
          {beginItems.map(
            ({
              id,
              title,
              subtitle,
              desc,
              navigationPath,
              guidingSteps,
              visualType,
              visualDesc,
              Icon,
            }) => {
              // const activeTab = activeTabs[id] || "nav";
              const activeTab = activeTabs[id] || "visual";

              return (
                <div
                  key={id}
                  className="bg-gray-50 border border-gray-200 rounded p-4 hover:bg-orange-50 transition"
                >
                  {/* Header */}
                  <div className="flex items-start">
                    <Icon className="h-8 w-8 text-orange-600" />
                    <div className="ml-3">
                      <p className="text-sm font-bold text-gray-800">{title}</p>
                      <p className="text-xs font-bold text-gray-500 mt-0.5">
                        {subtitle}
                      </p>
                    </div>
                  </div>

                  {/* Description */}
                  <p className="text-sm text-gray-600 mt-3">{desc}</p>

                  {/* Tabs */}
                  <div className="mt-4 flex space-x-2">
                    {[
                      { key: "nav", label: "Nav Path" },
                      { key: "steps", label: "Steps" },
                      { key: "visual", label: "Visualize" },
                    ].map((tab) => (
                      <button
                        key={tab.key}
                        onClick={() => handleTabChange(id, tab.key)}
                        className={`text-xs px-2 py-1 rounded border ${
                          activeTab === tab.key
                            ? "bg-orange-600 text-white border-orange-600"
                            : "bg-white text-gray-600 border-gray-200"
                        }`}
                      >
                        {tab.label}
                      </button>
                    ))}
                  </div>

                  {/* Tab Content */}
                  <div className="mt-3 bg-white border border-gray-200 rounded p-3">
                    {activeTab === "nav" && (
                      <div className="space-y-2">
                        {navigationPath.map((StepComp, index) => (
                          <div key={`${id}-nav-${index}`} className="flex items-start">
                            <div className="h-5 w-5 rounded-full bg-orange-100 text-orange-700 text-[11px] flex items-center justify-center mt-0.5">
                              {index + 1}
                            </div>
                            <p className="ml-2 text-sm text-gray-600 leading-6">
                              
                              {typeof StepComp === "function" ? <StepComp /> : StepComp}
                            </p>
                          </div>
                        ))}
                      </div>
                    )}

                    {/* 31 Mar 2026 Refined for Actions */}
                    {activeTab === "steps" && (
                      <div className="space-y-3">
                        {id === "actions" ? (
                          guidingSteps.map((StepComp, index) => (
                            <div key={`${id}-step-${index}`}>
                              {typeof StepComp === "function" ? <StepComp /> : StepComp}
                            </div>
                          ))
                        ) : (
                          guidingSteps.map((StepComp, index) => (
                            <div key={`${id}-step-${index}`} className="flex items-start">
                              <div className="h-6 w-6 min-w-[1.5rem] min-h-[1.5rem] rounded-full bg-orange-100 text-orange-700 text-[11px] font-semibold flex items-center justify-center mt-0.5 flex-shrink-0">
                                {index + 1}
                              </div>
                              <div className="ml-3 flex-1 text-sm text-gray-600 leading-6 text-left">
                                {typeof StepComp === "function" ? <StepComp /> : StepComp}
                              </div>
                            </div>
                          ))
                        )}
                      </div>
                    )}

                    {/* {activeTab === "steps" && (
                      <div className="space-y-2">
                        {guidingSteps.map((StepComp, index) => (
                          <div key={`${id}-step-${index}`} className="flex items-start">
                            <div className="h-5 w-5 rounded-full bg-orange-100 text-orange-700 text-[11px] flex items-center justify-center mt-0.5">
                              {index + 1}
                            </div>
                            <p className="ml-2 text-sm text-gray-600 leading-6">
                             {typeof StepComp === "function" ? <StepComp /> : StepComp}
                            </p>
                          </div>
                        ))}
                      </div>
                    )} */}

                    {activeTab === "visual" && (
                    <div>
                        <p className="text-xs font-bold text-orange-700">
                        {visualType}
                        </p>
                        <p className="text-sm text-gray-600 mt-1">
                        {visualDesc}
                        </p>

                        {id === "morning" ? (
                        <EtTrinityMorningHabitsChartDemo />
                        ) : id === "reflections" ? (
                        <EtTrinityReflectionsChartDemo />
                        ) : id === "conversations" ? (
                        <EtTrinityConversationsChartDemo />
                        ) : id === "creations" ? (
                        <EtTrinityCreationsChartDemo />
                        ) : id === "actions" ? (
                          <EtTrinityActionsChartDemo />
                        ) :  (
                        <div className="mt-2 h-20 rounded border border-dashed border-orange-200 flex items-center justify-center text-xs text-gray-400">
                            Chart preview
                        </div>
                        )}
                    </div>
                    )}
                  </div>
                </div>
              );
            }
          )}
        </div>
      </div>

      {/* 3️⃣ Close */}
      <div className="bg-gray-50 border border-gray-200 rounded p-4">
        <p className="text-sm text-gray-700">
          Start with a few habits. Build consistency. Let momentum follow.
        </p>
      </div>
    </div>
  );
};

export default EtTrinityOnboardingBeginContent;